module.exports = __webpack_public_path__ + "media/Loops 110 Bass.04c6deb6.wav";